import type { ComponentProps } from "react"

export default function PropertyCulture(
  props: ComponentProps<"svg"> & { fill?: string },
) {
  const { fill = "currentColor", ...svgProps } = props

  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.75497 0.0684323C1.34844 -0.0669875 0.901339 0.00113732 0.55372 0.251687C0.206028 0.502289 0 0.904753 0 1.33334V20.6667C0 23.1473 1.46997 25.656 3.86401 26.6876L15.4545 31.8833C15.8056 32.0407 16.2075 32.0388 16.5569 31.8781L28.1421 26.5516C30.5155 25.5263 32 23.1645 32 20.5333V1.33334C32 0.904753 31.794 0.502289 31.4463 0.251687C31.0987 0.00112985 30.6517 -0.0670763 30.2452 0.0683598L30.2417 0.0695359L30.2269 0.0744123L30.1639 0.0949942C30.1072 0.113367 30.0217 0.140818 29.9097 0.176051C29.6857 0.246531 29.3557 0.348082 28.938 0.470361C28.1019 0.715075 26.9169 1.04196 25.528 1.36878C22.7323 2.02658 19.1817 2.66668 16 2.66668C12.8183 2.66668 9.26768 2.02658 6.47205 1.36878C5.08301 1.04196 3.89815 0.715075 3.06203 0.470361C2.64425 0.348082 2.31427 0.246531 2.09024 0.176051C1.97825 0.140818 1.8928 0.113367 1.83615 0.0949942L1.77308 0.0744123L1.75829 0.0695359L1.75497 0.0684323ZM6.66667 17.3333C6.66667 19.388 7.92584 21.0864 9.6104 22.2095C11.3064 23.3401 13.5712 24 16 24C18.4288 24 20.6936 23.3401 22.3896 22.2095C24.0741 21.0864 25.3333 19.388 25.3333 17.3333H22.6667C22.6667 18.212 22.1259 19.1803 20.9104 19.9905C19.7064 20.7932 17.9712 21.3333 16 21.3333C14.0288 21.3333 12.2936 20.7932 11.0896 19.9905C9.87416 19.1803 9.33333 18.212 9.33333 17.3333H6.66667ZM4 12C4 9.54222 6.34727 8.00001 8.66667 8.00001C10.9861 8.00001 13.3333 9.54222 13.3333 12H10.6667C10.6667 11.5245 10.0806 10.6667 8.66667 10.6667C7.25273 10.6667 6.66667 11.5245 6.66667 12H4ZM21.3333 12C21.3333 11.5245 21.9193 10.6667 23.3333 10.6667C24.7473 10.6667 25.3333 11.5245 25.3333 12H28C28 9.54222 25.6527 8.00001 23.3333 8.00001C21.014 8.00001 18.6667 9.54222 18.6667 12H21.3333Z"
        fill={fill}
      />
    </svg>
  )
}
